/**
 * Sekmeler arası platform oturumu olayları (panelin `session-channel.ts`'inin karşılığı; kanal adı ayrıdır): bir sekmede
 * oturum kapanınca diğerleri de kapanır; başka kişi oturum açınca diğer sekmeler önbelleği temizleyip yeni oturumu yükler.
 */
export type SessionMessage = { readonly type: 'logout' } | { readonly type: 'login'; readonly userId: string | null };

export const SESSION_CHANNEL = 'ticarishift.platform.session';

export type SessionChannel = {
  post(message: SessionMessage): void;
  close(): void;
};

export function openSessionChannel(onMessage: (message: SessionMessage) => void): SessionChannel {
  if (typeof BroadcastChannel === 'undefined') {
    return { post: () => undefined, close: () => undefined };
  }

  const channel = new BroadcastChannel(SESSION_CHANNEL);
  channel.onmessage = (event: MessageEvent<SessionMessage>) => onMessage(event.data);
  return {
    post: (message) => channel.postMessage(message),
    close: () => channel.close(),
  };
}
